import AnnouncementContainer from './AnnouncementContainer';

export default AnnouncementContainer;
